<template>
  <div class='list-box'>
    <template v-if="list.length">
      <div class="item-box" v-for="(item, index) in  list " :key="index" @click="viewDetail(item)">
        <div class="user_info_box">
          <div class="user_info">
            <img alt="" class="user_img"
                 :src="item.userAvatar?item.userAvatar:`https://hospital-runsheng.oss-cn-shenzhen.aliyuncs.com/runsheng-wx/avatar.png`"/>
            <div class="user_name">
              <div class="name">{{ item.userNickName }}</div>
              <div class="age">{{ item.payTime }}</div>
            </div>
          </div>
          <p class="order_status">{{ getOrderStatusText(item) }}</p>
        </div>
        <div class="product_info_box" v-if="item.orderGoods[0] && item.orderGoods.length <= 1">
          <img alt="" class="product_pic"
               :src="item.orderGoods[0].thumPic">
          <div class="product_info">
            <div class="product_info_top">
              <div class="product_name">{{ item.orderGoods[0].name }}</div>
              <div class="product_specifications" v-if="item.orderGoods[0].skuProperties">
                <span v-for="(itemSku, index) in JSON.parse(item.orderGoods[0].skuProperties || '[]')"
                      :key="index">
                  {{ itemSku.value }}
                  <span class="m-l-10 m-r-10"
                        v-if="JSON.parse(item.orderGoods[0].skuProperties || '[]').length - 1 != index">;
                  </span>
                </span>
              </div>
              <div class="product_specifications" v-else>默认规格</div>
            </div>
            <div class="product_price_num">
              <div class="product_price">¥{{ Number(item.orderGoods[0].price) }}</div>
              <div class="product_num">×{{ item.orderGoods[0].count }}</div>
            </div>
          </div>
        </div>
        <div class="multiple_product_info_box" v-else>
          <div class="multiple_products_box">
            <div class="product_pic_box" v-for="goodItem in item.orderGoods" :key="goodItem.id">
              <img alt=""
                   class="product_pic"
                   :src="goodItem.thumPic">
              <div class="product_num">×{{ goodItem.count }}</div>
            </div>
          </div>
        </div>
        <p class="order_amount">订单金额 <span class="amount">￥{{ Number(item.totalMoney) }}</span></p>
        <p>归属工作室：{{ item.studioName }}</p>
        <div class="button-box" v-if="item.newStatus==2||(item.newStatus==1&&item.subStatus==11)||item.newStatus==3">
          <van-button type="info" plain square size="small" @click.stop="viewLogic(item)" class="write-box">查看物流
          </van-button>
        </div>
      </div>
      <div class="pagination" v-if="page.total > page.pageSize" style="padding: 20px 0;">
        <van-pagination v-model="page.pageNo" :total-items="page.total" :items-per-page="page.pageSize"
                        @change="pageChange">
          <template #prev-text>
            <van-icon name="arrow-left"/>
          </template>
          <template #next-text>
            <van-icon name="arrow"/>
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
      </div>
    </template>
    <van-empty description="暂无数据" v-else/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {getGoodsOrderList} from "@/api/home";

export default {
  name: 'productorder-list',
  components: {},
  data() {
    return {
      list: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        q: '',
        total: 0,
      },
    }
  },
  methods: {
    getOrderStatusText(item) {
      let {newStatus, subStatus} = item
      switch (newStatus) {
        case 0:
          return '待付款'
        case 1:
          if (subStatus == 10) {
            return '待发货'
          } else if (subStatus == 11) {
            return '部分发货'
          } else if (subStatus == 20) {
            return '待提货'
          } else if (subStatus == 30) {
            return '排单中'
          } else if (subStatus == 31) {
            return '部分排单'
          } else {
            return ''
          }
        case 2:
          return '待收货'
        case 3:
          return '已完成'
        case 4:
          return '已关闭'
        case 5:
          return '已取消'
        case 6:
          return '已退款'
        case 7:
          return '部分发货'
        default:
          return ''
      }
    },
    async setPageParams(keyword) {
      console.log(keyword);
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.q = keyword
      await this.getPageList()
    },
    async getPageList() {
      try {
        const params = {
          ...this.page,
          assistantNo: this.$store.state.assistantNo
        }
        const {data: {list, total}} = await getGoodsOrderList(params)
        list.forEach((item) => {
          item.allCount = 0
          item.items?.forEach((val) => {
            item.allCount += Number(val.quantity)
          })
        })

        this.list = list
        console.log(this.list);
        this.page.total = total
      } catch (error) {
        this.list = []
        console.log(error)
      }
    },
    // 查看物流
    viewLogic(item) {
      this.$router.push({
        path: '/teamOrders/logistics/index',
        query: {
          askNo: item.id,
        }
      })
    },
    // 详情
    viewDetail(item) {
      this.$router.push({
        path: '/teamOrders/productDetail/index',
        query: {
          id: item.id,
        }
      })
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo
      this.getPageList()
    },

  },
  computed: {
    ...mapGetters(['getLoginRole']),
  },
  watch: {},
  created() {
    this.getPageList()
  },
  activated() {
    this.getPageList()
  }
}
</script>
<style lang='scss' scoped>
.list-box {

  .item-box {
    background: #fff;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    & + .item-box {
      margin-top: 15px;
    }

    .user_info_box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .user_info {
        display: flex;

        .user_img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .user_name {
          margin-left: 8px;

          .name {
          }

          .age {
            color: #6d6d6e;
            margin-top: 4px;
          }
        }

      }

      .order_status {
      }
    }

    .product_info_box {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      border-bottom: 0.5px solid #E4E6E6;
      padding-bottom: 12px;
      box-sizing: border-box;

      .product_pic {
        width: 120px;
        height: 120px;
        border-radius: 12px;
      }

      .product_info {
        margin-left: 16px;
        width: calc(100% - 120px - 16px);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        justify-content: space-between;
        line-height: 1;


        .product_name {
          font-size: 16px;
          color: #1B2120;
        }

        .product_specifications {
          font-size: 13px;
          color: #7C807F;
          margin-top: 16px;
        }

        .product_price_num {
          display: flex;
          justify-content: space-between;
          font-weight: bold;
          font-size: 14px;
          color: #1B2120;

        }
      }
    }

    .multiple_product_info_box {
      width: 100%;
      margin-top: 20px;
      overflow-x: auto;


      .multiple_products_box {
        display: flex;
        flex-direction: row;
      }

      .product_pic_box {
        width: 120px;
        height: 120px;
        border-radius: 24px;
        position: relative;
        margin-right: 16px;

        .product_pic {
          width: 120px;
          height: 120px;
          border-radius: 24px;
        }

        .product_num {
          position: absolute;
          bottom: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 31px;
          height: 30px;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 12px 0px 12px 0px;
          font-weight: bold;
          font-size: 14px;
          color: #FFFFFF;
        }
      }
    }

    .order_amount {
      text-align: right;

      .amount {
        color: #dc0e0e;
      }
    }

    .button-box {
      display: flex;
      margin-top: 10px;
      justify-content: flex-end;

      .write-box {
        margin-left: 12px;
        border-radius: 8px;
        height: 30px;

        &.van-button--plain {
          background: #f5f5f5;
        }
      }
    }
  }
}
</style>